<template>
  <div>
    <div v-if="startTimeIsInFuture" class="text-center card">
      <div class="card-body py-5">
        <flip-countdown :deadline="localStart"></flip-countdown>
      </div>
    </div>
    <div class="alert alert-warning" v-else-if="endTimeIsInPast">
      This session has ended! Check <router-link to="/live"><strong>here</strong></router-link> to find other sessions.
    </div>
    <div class="alert alert-info" v-if="shouldGoLiveNow">Session has started! Click <strong role="button" @click="reloadPage">here</strong> to reload.</div>
  </div>
</template>

<script>
import FlipCountdown from 'vue2-flip-countdown';
import moment from 'moment';
export default {
  props: ['start', 'duration'],
  components: { FlipCountdown },
  mounted() {
    setInterval(() => {
      this.shouldGoLiveNow = moment().isAfter(moment.utc(this.start)) && moment().isBefore(moment.utc(this.start).add(this.duration, 'minutes'));
    }, 1000);
  },
  computed: {
    localStart() {
      let start = moment
        .utc(this.start)
        .local()
        .format('YYYY-MM-DD HH:mm:ss');
      console.log(start);
      return start;
    },
    startTimeIsInFuture() {
      return moment().isBefore(moment.utc(this.start));
    },
    endTimeIsInPast() {
      return moment().isAfter(moment.utc(this.start).add(this.duration, 'minutes'));
    },
  },
  data() {
    return {
      shouldGoLiveNow: false,
    };
  },
  methods: {
    reloadPage() {
      location.reload();
    },
  },
};
</script>

<style scoped></style>
